import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"
import {GraphNode} from "@cm/graph-v3"
import {CombineXyz} from "#material/nodes/converter/combine-xyz/combine-xyz"
import {materialConnection} from "#material/nodes/base/connection/shorthand"

export function combineXyz(
    x: InputMaterialConnection<"float"> | number,
    y: InputMaterialConnection<"float"> | number,
    z: InputMaterialConnection<"float"> | number,
): OutputMaterialConnection<"vector"> {
    const combineRgbNode = new CombineXyz({
        parameters: {
            inputs: {
                x: x instanceof GraphNode ? x : undefined,
                y: y instanceof GraphNode ? y : undefined,
                z: z instanceof GraphNode ? z : undefined,
            },
            settings: {
                x: x instanceof GraphNode ? undefined : x,
                y: y instanceof GraphNode ? undefined : y,
                z: z instanceof GraphNode ? undefined : z,
            },
        },
    })
    return materialConnection(combineRgbNode, "vector")
}
